module.exports = __webpack_public_path__ + "static/media/DqEveryChildChallengePhoto2.b7a69664.jpg";